import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import SeoData from '../../Dumbo/_partials/SeoData';
import Image from './Image';
const IMAGE_WRAPPER_SEO_PROPS = {
    typeof: 'ImageObject',
    vocab: 'https://schema.org/'
};
const IMAGE_PROPS = {
    // SEO
    property: 'contentUrl',
    // react doesn't know about this yet...
    fetchPriority: 'high'
};
/** Wrapped version of FullImage that adds SEO data only needed
 *  for full deviations */ export const ImageDeviation = (_param)=>{
    var { deviation } = _param, props = _object_without_properties(_param, [
        "deviation"
    ]);
    return /*#__PURE__*/ React.createElement(Image, _object_spread({
        source: deviation,
        allowFullviewSrcsetForPngs: deviation.isPublished,
        altText: deviation.title,
        wrapperProps: IMAGE_WRAPPER_SEO_PROPS,
        imageProps: IMAGE_PROPS,
        afterImage: /*#__PURE__*/ React.createElement(SeoData, {
            deviation: deviation
        })
    }, props));
};
ImageDeviation.displayName = 'ImageDeviation';
export default ImageDeviation;

//# sourceMappingURL=ImageDeviation.js.map